/**
 * Reducer for the list of supported currencies. TODO: Think about removing / collapsing this. Is this overkill?
 */

import { ActionTypes as types } from '../constants'
import serverProps from '../lib/server-props'

const countries = serverProps.sendableCountryList || [] // populated from fees.dust. All countries we can send to (both via P2p / XOOM).
const currencyTypes = serverProps.currencyTypes || []

// { USD: '$', /* ... */ }
const currencySymbols = countries.reduce((accumulator, country) => {
  accumulator[country.currencyCode] = country.currencySymbol
  return accumulator
}, {})

// Initial State for this part of the store. Immutable.
const initialState = {
  supportedCurrencyCodes: [],
  availableCurrencies: currencyTypes,
  currencySymbols,
}

/**
 * Reducer. Pure function that mutates the state above and returns a new obj.
 *
 */
export default function currencyCode(state = initialState, action) {
  if (action.type === types.RECEIVED_CURRENCY_CODE_LIST) {
    const newAvailableCurrencies =
      state.availableCurrencies.length > 0
        ? state.availableCurrencies
        : action.data.currencies

    return {
      ...state,
      availableCurrencies: newAvailableCurrencies,
      supportedCurrencyCodes: action.data.currencies,
    }
  }

  return state
}
